import React from 'react';
import { EyeFilled } from '@ant-design/icons';

export const EyeOpen = (props) => (
    <EyeFilled style={{ fontSize: '18px', color: '#006ce8', marginRight: '5px', marginTop: '2px' }} {...props} />
);
